// source: mti/store/ram/ram_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.mti.store.ram.RamStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mti.store.ram.RamStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mti.store.ram.RamStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mti.store.ram.RamStatus.displayName = 'proto.mti.store.ram.RamStatus';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mti.store.ram.RamStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.mti.store.ram.RamStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mti.store.ram.RamStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.ram.RamStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    serialNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    batteryLevel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lostCommunication: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    identifying: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    charging: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    powered: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    keyInserted: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    keySerialNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    model: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hardwareVersion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    firmwareVersion: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mti.store.ram.RamStatus}
 */
proto.mti.store.ram.RamStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mti.store.ram.RamStatus;
  return proto.mti.store.ram.RamStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mti.store.ram.RamStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mti.store.ram.RamStatus}
 */
proto.mti.store.ram.RamStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBatteryLevel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLostCommunication(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdentifying(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCharging(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPowered(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setKeyInserted(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeySerialNumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHardwareVersion(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mti.store.ram.RamStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mti.store.ram.RamStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mti.store.ram.RamStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.ram.RamStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerialNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBatteryLevel();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getLostCommunication();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIdentifying();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCharging();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPowered();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getKeyInserted();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getKeySerialNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHardwareVersion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string serial_number = 1;
 * @return {string}
 */
proto.mti.store.ram.RamStatus.prototype.getSerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setSerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 battery_level = 2;
 * @return {number}
 */
proto.mti.store.ram.RamStatus.prototype.getBatteryLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setBatteryLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool lost_communication = 3;
 * @return {boolean}
 */
proto.mti.store.ram.RamStatus.prototype.getLostCommunication = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setLostCommunication = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool identifying = 4;
 * @return {boolean}
 */
proto.mti.store.ram.RamStatus.prototype.getIdentifying = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setIdentifying = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool charging = 5;
 * @return {boolean}
 */
proto.mti.store.ram.RamStatus.prototype.getCharging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setCharging = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool powered = 6;
 * @return {boolean}
 */
proto.mti.store.ram.RamStatus.prototype.getPowered = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setPowered = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool key_inserted = 7;
 * @return {boolean}
 */
proto.mti.store.ram.RamStatus.prototype.getKeyInserted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setKeyInserted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string key_serial_number = 8;
 * @return {string}
 */
proto.mti.store.ram.RamStatus.prototype.getKeySerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setKeySerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string model = 9;
 * @return {string}
 */
proto.mti.store.ram.RamStatus.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string hardware_version = 10;
 * @return {string}
 */
proto.mti.store.ram.RamStatus.prototype.getHardwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setHardwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string firmware_version = 11;
 * @return {string}
 */
proto.mti.store.ram.RamStatus.prototype.getFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.ram.RamStatus} returns this
 */
proto.mti.store.ram.RamStatus.prototype.setFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


goog.object.extend(exports, proto.mti.store.ram);
